import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useEffect, useRef, useState } from 'react';
import { PrimaryButton } from '@rexlabs/button';
import { ControlledTabs as RexLabsTabs } from '@rexlabs/tabs';
import { Form as RexLabsForm } from '@rexlabs/form';
import { FormRenderer } from './';

function DefaultRenderer(_ref) {
  var _ref$SubmitButton = _ref.SubmitButton,
      SubmitButton = _ref$SubmitButton === void 0 ? PrimaryButton : _ref$SubmitButton,
      _ref$Label = _ref.Label,
      Label = _ref$Label === void 0 ? 'div' : _ref$Label,
      rest = _objectWithoutProperties(_ref, ["SubmitButton", "Label"]);

  return /*#__PURE__*/React.createElement(FormRenderer, rest, function (_ref2) {
    var defaultDescriptionViewProps = _ref2.defaultDescriptionViewProps,
        schema = _ref2.schema,
        defaultViewProps = _objectWithoutProperties(_ref2, ["defaultDescriptionViewProps", "schema"]);

    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, null, schema.definition.label), /*#__PURE__*/React.createElement(DefaultDescriptionView, defaultDescriptionViewProps), /*#__PURE__*/React.createElement(DefaultFormView, defaultViewProps), /*#__PURE__*/React.createElement(SubmitButton, {
      type: "submit"
    }, "Submit"));
  });
}

function copyStyleSheets(iframe) {
  if (iframe.current) {
    var _context;

    var iframeDocument = iframe.current.contentDocument;

    _forEachInstanceProperty(_context = _Array$from(window.top.document.styleSheets)).call(_context, function (styleSheet) {
      try {
        if (styleSheet.cssRules) {
          var _context2;

          // for <style> elements
          var newStyleEl = document.createElement('style');

          _forEachInstanceProperty(_context2 = _Array$from(styleSheet.cssRules)).call(_context2, function (cssRule) {
            var _styleSheet$ownerNode;

            if (((_styleSheet$ownerNode = styleSheet.ownerNode) === null || _styleSheet$ownerNode === void 0 ? void 0 : _styleSheet$ownerNode.id) !== 'form-renderer' && cssRule.type !== CSSRule.FONT_FACE_RULE) {
              return;
            } // write the text of each rule into the body of the style element


            newStyleEl.appendChild(document.createTextNode(cssRule.cssText));
          });

          if (newStyleEl.childNodes.length > 0) {
            iframeDocument.head.appendChild(newStyleEl);
          }
        }
      } catch (error) {
        console.error(error);
      }
    });
  }
}

function updateIframe(iframe, html, setIframeHeight) {
  if (iframe.current) {
    var iframeDocument = iframe.current.contentDocument;
    var container = document.createElement('div');
    container.innerHTML = html;
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    iframeDocument.body.appendChild(container);
    iframeDocument.body.style.margin = '0px';
    iframeDocument.body.className = 'form-renderer';
    setIframeHeight(container.getBoundingClientRect().height);
  }
}

function DefaultDescriptionView(_ref3) {
  var html = _ref3.html;
  var iframe = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      iframeHeight = _useState2[0],
      setIframeHeight = _useState2[1];

  useEffect(function () {
    copyStyleSheets(iframe);
    updateIframe(iframe, html, setIframeHeight);
  }, []);
  useEffect(function () {
    updateIframe(iframe, html, setIframeHeight);
  }, [html]);
  return html ? /*#__PURE__*/React.createElement("iframe", {
    title: "Form description",
    sandbox: "allow-same-origin allow-top-navigation",
    ref: iframe,
    style: {
      height: "".concat(iframeHeight, "px"),
      width: '100%',
      backgroundColor: 'transparent',
      border: '0px none transparent',
      padding: '0px',
      overflow: 'hidden'
    }
  }) : null;
}

var DefaultFormView = function DefaultFormView(_ref4) {
  var schema = _ref4.schema,
      tabProps = _ref4.tabProps,
      _ref4$Form = _ref4.Form,
      Form = _ref4$Form === void 0 ? RexLabsForm : _ref4$Form,
      _ref4$Tabs = _ref4.Tabs,
      Tabs = _ref4$Tabs === void 0 ? RexLabsTabs : _ref4$Tabs;
  return /*#__PURE__*/React.createElement(Form, {
    name: schema === null || schema === void 0 ? void 0 : schema.name
  }, /*#__PURE__*/React.createElement(Tabs, tabProps));
};

export { DefaultDescriptionView, DefaultFormView };
export default DefaultRenderer;